import {Dimensions, Platform} from 'react-native';

const {width: screenWidth} = Dimensions.get('window');
const MODAL_WIDTH_MULTIPLIER = Platform.OS === 'web' ? 0.3 : 0.92;
export const MODAL_WIDTH = screenWidth * MODAL_WIDTH_MULTIPLIER;
